import { useState } from 'react';
import { CustomLayout } from '@/components/ui/custom-layout';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { supabase } from '@/integrations/supabase/client';

export default function ClaudeRawTest() {
  const [resumeText, setResumeText] = useState('');
  const [jobDescription, setJobDescription] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [loading, setLoading] = useState(false);
  const [rawResponse, setRawResponse] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [elapsed, setElapsed] = useState<number | null>(null);

  const handleTailor = async () => {
    setLoading(true);
    setError(null);
    setRawResponse(null);
    setElapsed(null);
    const start = Date.now();
    try {
      const { data, error: fnError } = await supabase.functions.invoke('tailor-resume-claude-v2', {
        body: { resumeText, jobDescription, companyName, jobTitle, tailoringSource: 'job-description' }
      });
      setElapsed((Date.now() - start) / 1000);
      if (fnError) {
        setError(JSON.stringify(fnError, null, 2));
      } else {
        setRawResponse(data);
      }
    } catch (e: any) {
      setElapsed((Date.now() - start) / 1000);
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomLayout title="Claude Raw Test" backTo="/">
      <div className="flex w-full h-[calc(100vh-64px)]">
        {/* Left: Inputs */}
        <div className="w-1/3 p-4 space-y-4 overflow-y-auto border-r border-border">
          <div>
            <Label>Resume Text</Label>
            <Textarea rows={8} value={resumeText} onChange={e => setResumeText(e.target.value)} placeholder="Paste resume text..." />
          </div>
          <div>
            <Label>Job Description</Label>
            <Textarea rows={8} value={jobDescription} onChange={e => setJobDescription(e.target.value)} placeholder="Paste job description..." />
          </div>
          <div>
            <Label>Company Name</Label>
            <Input value={companyName} onChange={e => setCompanyName(e.target.value)} placeholder="Company" />
          </div>
          <div>
            <Label>Job Title</Label>
            <Input value={jobTitle} onChange={e => setJobTitle(e.target.value)} placeholder="Job Title" />
          </div>
          <Button onClick={handleTailor} disabled={loading || !resumeText || !jobDescription} className="w-full">
            {loading ? 'Tailoring...' : 'Tailor'}
          </Button>
        </div>

        {/* Right: Raw Response */}
        <div className="w-2/3 p-4 overflow-auto">
          <Label className="mb-2 block">
            Raw Response (Claude v2 — parallel)
            {elapsed !== null && <span className="ml-2 font-normal text-muted-foreground">— completed in {elapsed.toFixed(1)}s</span>}
          </Label>
          {error && <pre className="text-red-500 text-xs whitespace-pre-wrap">{error}</pre>}
          {rawResponse && (
            <pre className="text-xs whitespace-pre-wrap bg-muted p-4 rounded-md">
              {JSON.stringify(rawResponse, null, 2)}
            </pre>
          )}
          {!rawResponse && !error && <p className="text-muted-foreground text-sm">Response will appear here.</p>}
        </div>
      </div>
    </CustomLayout>
  );
}
